import { render, staticRenderFns } from "./ModalFDS.vue?vue&type=template&id=611294db"
import script from "./ModalFDS.vue?vue&type=script&lang=js"
export * from "./ModalFDS.vue?vue&type=script&lang=js"
import style0 from "./ModalFDS.vue?vue&type=style&index=0&id=611294db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports